<dv-dialog-content>
  <div>
    <p>
      {{ 'LocationAccess.Info' | translate }}
    </p>

    <p>{{ 'LocationAccess.TurnBackOn' | translate }}:</p>

    <ol>
      <li>{{ 'LocationAccess.OpenSiteSettings' | translate }}</li>
      <li>{{ 'LocationAccess.FindLocation' | translate }}</li>
      <li>{{ 'LocationAccess.ChangeLocationSetting' | translate }}</li>
    </ol>

    <p>{{ 'LocationAccess.AfterEnabling' | translate }}</p>
  </div>
  <dv-button footer-right color="secondary" (click)="onClose()">
    {{ 'Button.Close' | translate }}
  </dv-button>
</dv-dialog-content>
